import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import logo from "../joinlogo.png";

export default function SectionScaffold({
  title,
  cancelText,
  onCancel,
  topChildren,
  bottomChildren,
  footer,
  footerNote,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #d4ebf2, #f2f2f2)",
        padding: "20px",
      }}
    >
      <Box
        sx={{
          width: "90%",
          margin: "0 auto",
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "20px",
          boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Stack
          spacing={3}
          alignItems="center"
          marginTop={4}
          marginBottom={20}
          paddingInline={4}
        >
          <img src={logo} alt="logo" style={{ width: 200 }} />
          <Typography
            variant="h2"
            align="center"
            color="#1EABF1"
            fontSize={30}
            fontFamily="Trueno Light"
            sx={{ paddingBottom: 2 }}
          >
            {title}
          </Typography>
          <Stack
            spacing={2}
            direction="row"
            justifyContent="space-between"
            width="80%"
            sx={{ marginBottom: 2 }}
          >
            <Button
              variant="outlined"
              color="primary"
              sx={{ opacity: 0.6 }}
              onClick={onCancel}
            >
              {cancelText}
            </Button>
          </Stack>
          <Divider
            sx={{
              width: "85%",
              backgroundColor: "rgba(30, 171, 241, 0.2)",
              height: "1px",
            }}
          />
          <Stack
            spacing={13}
            direction="row"
            justifyContent="center"
            sx={{ paddingTop: 5 }}
          >
            {topChildren}
          </Stack>
          <Stack
            direction="row"
            spacing={2}
            sx={{ width: "100%", padding: 2, boxSizing: "border-box" }} // Full width and padding
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                gap: 2,
                padding: 2,
              }}
            >
              {bottomChildren}
            </Box>
          </Stack>
          <Divider
            sx={{
              width: "85%",
              backgroundColor: "rgba(30, 171, 241, 0.2)",
              height: "1px",
            }}
          />
          {footer}
          {footerNote ? (
            <Typography
              variant="h1"
              align="center"
              fontSize={14}
              fontFamily="Trueno Light"
              fontStyle="italic"
            >
              {footerNote}
            </Typography>
          ) : null}
        </Stack>
      </Box>
    </Box>
  );
}
